module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_04-8a8985683af426f42ed43f3660facaa1.jpg";